
import { Component, Vue } from 'vue-property-decorator'
import http from '@/utils/request'
import { getUserInfo } from '@/utils/user'
import i18n from '@/lang'

@Component
export default class extends Vue {
  private form = {
    totalLoanAmount: '',
    tkb90: '',
    totaolUnRepayAmount: '',
    totalProfit: '',
    totalBidNum: '',
    accountNumber: '',
    accountBalance: '',
    rdlBalance: ''
  }

  private list: any[] = []
  private listLoading = false
  private listTotal = 0
  private listQuery = {
    current: 1,
    size: 10
  }

  private bcank = {
    accountNumber: '',
    amount: ''
  }

  rules = {
    accountNumber: [{ required: true, message: i18n.t('Silahkan pilih'), trigger: 'change' }],
    amount: [{ required: true, message: i18n.t('Silahkan masukan'), trigger: 'change' }]
  }

  showThirdPartyDialog = false

  created() {
    this.getBoardData()
    this.getList()
    /* this.getAccount() */
  }

  getBoardData() {
    http.post('/lend/dataBoard').then((data) => {
      data.tkb90 = data.tkb90 + '%'
      this.form = { ...this.form, ...data }
    })
  }

  getAccount() {
    http.post('/rdl/accountBalance').then((data) => {
      if (data.accountNumber === '' || data.accountNumber === null) {
        this.form.accountBalance = '0'
        /* this.validateAccount() */
      } else {
        this.form.accountNumber = data.accountNumber
        this.form.accountBalance = data.accountBalance
      }
    })
  }

  validateAccount() {
    http.post('/rdl/validateAccount').then((data) => {
      if (data.accountStatus) {
        this.getBoardData()
      }
    })
  }

  onSearch() {
    this.showThirdPartyDialog = true
  }

  onClose() {
    ;(this.$refs.form as any).resetFields()
  }

  onyes() {
    ;(this.$refs.form as any).validate((valid: any) => {
      if (valid) {
        const { mid: customerId } = getUserInfo('userInfoMap')
        const lq = {
          accountNumber: this.bcank.accountNumber,
          amount: Number(this.bcank.amount),
          customerId
        }

        return http.post('/lend/api/withdraw', lq).then((res) => {
          console.log(res)
          if (res) {
            this.showThirdPartyDialog = false
            this.getList()
            this.$message({
              message: i18n.t('Penarikan berhasil') as string,
              type: 'success'
            })
          } else {
            this.$message.error(i18n.t('Penarikan gagal') as string)
          }
        })
      } else {
        console.log('error submit!!')
        return false
      }
    })
  }

  handleSizeChange(val: number) {
    this.listQuery.size = val
    this.getList()
  }

  handleCurrentChange(val: number) {
    this.listQuery.current = val
    this.getList()
  }

  private async getList() {
    this.listLoading = true
    this.initialize().finally(() => (this.listLoading = false))
  }

  //  Tabular data source
  async initialize() {
    const lq = {
      pageNum: this.listQuery.current,
      pageSize: this.listQuery.size
    }

    return http.post('/lend/rdlAccountDetail', lq).then((data) => {
      this.list = data.recordList
      this.listTotal = data.totalPage
    })
  }
}
